import { Button, Drawer, Grid } from 'antd';
import { ChevronLeft } from 'lucide-react';
import Link from 'next/link';
import React, { ReactNode, useEffect } from 'react';

type Props = {
  onClose: () => void;
  visible: boolean;
  className?: string;
  goBack?: boolean;
  head?: React.ReactElement;
  closable?: boolean;
  children?: ReactNode;
};

export const MainDrawer: React.FC<Props> = ({
  onClose,
  visible,
  className,
  goBack = true,
  children,
  head,
  closable = true,
}) => {
  const { xl } = Grid.useBreakpoint();

  useEffect(() => {
    if (xl) {
      onClose();
    }
  }, [xl, onClose]);

  return (
    <Drawer
      title={
        head || (
          <Link href="/" className="headerLogo">
            <img src="/images/theboatdb-logo-white.svg" alt="TheBoatDB Logo" />
          </Link>
        )
      }
      placement="right"
      className={className}
      closable={closable}
      onClose={onClose}
      open={visible}
    >
      {goBack && (
        <Button
          key="more-go-back"
          type="text"
          onClick={onClose}
          icon={<ChevronLeft size={16} />}
          style={{
            display: 'flex',
            alignItems: 'center',
            color: 'var(--gray-1)',
            marginBottom: 8,
          }}
        >
          Back
        </Button>
      )}

      <>{children}</>
    </Drawer>
  );
};
